import React, { useRef, useEffect, useState, useImperativeHandle, forwardRef } from 'react';
import { Parallax } from '@react-spring/parallax';
import { categoriesData, Page } from './ParallaxContent';
import './ParallaxSystem.css';

const ParallaxSystem = forwardRef(({ category = 'GTMR', language }, ref) => {
  const parallax = useRef(null);
  const [currentPage, setCurrentPage] = useState(0);

  const scroll = (to) => {
    if (parallax.current) {
      parallax.current.scrollTo(to);
      setCurrentPage(to);
    }
  };

  useEffect(() => {
    if (['fortunam', 'monteRosa', 'OAM'].includes(category)) {
      const initialOffset = categoriesData.fortunam_monteRosa_OAM.findIndex(item => item.modelName === category);
      scroll(initialOffset);
    }
  }, [category]);

  const categoryPages = categoriesData[category];

  const goToNextPage = () => {
    const nextPage = currentPage + 1;
    if (nextPage < categoryPages.length) {
      scroll(nextPage);
    } else {
      scroll(0); // Retour au début
    }
  };

  const goToPreviousPage = () => {
    const previousPage = currentPage - 1;
    if (previousPage >= 0) {
      scroll(previousPage);
    } else {
      scroll(categoryPages.length - 1); // Retour à la dernière diapositive
    }
  };

  // Exposez goToNextPage et goToPreviousPage via ref
  useImperativeHandle(ref, () => ({
    goToNextPage,
    goToPreviousPage,
  }));

  return (
    <div>
      <Parallax className='container' ref={parallax} pages={categoryPages.length} horizontal>
        {categoryPages.map((page, index) => (
          <Page
            key={index}
            offset={index}
            gradient="glass"
            onClick={goToNextPage} // Déclenche le défilement vers la diapositive suivante
            backgroundImage={page.backgroundImage}
            modelName={category}
            language={language}
            pageIndex={index}  // ajout de l'indice de la page
          />
        ))}
      </Parallax>
    </div>
  );
});

export default ParallaxSystem;